<template lang="html">
  	<div class="vipInContainer">
  		<div class="text-container" v-show="!vipSuccess">
	  		<div class="title">入会须知</div>
	  		<div class="content">
	  			1、凡是资产达到一定级别的客户可成为对应级别的君弘财富俱乐部会员；
	  		</div>
	  		<div class="content">
	  			2、君弘财富俱乐部会员权益会随时间推移不断升级和调整。最终解释权归国泰君安证券股份有限公司所有。
	  		</div>
	  		<div class="state">
	  			<div v-bind:class="['imgContainer',readingIndex?'':'not-confirm']" v-on:click="reading">
	  				<img src="../../assets/img/state-icon.png" />
	  			</div>
	  			<div class="state-text">我已阅读</div>
	  		</div>
	  		<div class="confirmBox">
	  			<div class="cancle" v-on:click="cancle">我再看看</div>
	  			<div class="confirm" v-on:click="confirm">确认，我要入会</div>
	  		</div>
	  	</div>
	  	<div class="resulr-container" v-show="vipSuccess">
	  		<div class="result-bg">
	  			<div class="result-text">
	  				<img src="../../assets/img/result-vip-in.png" />
	  				<div class="result-wel">欢迎您加入君弘财富俱乐部</div>
	  			</div>
	  		</div>
	  		<div class="result-confirm" v-on:click="vipInSucc">好的</div>
	  	</div>
  	</div>
</template>
<script>
	import $ from 'jquery'
	import Server from '../../server/server.js'
	import {alertMsg} from '../../common/url.js';
	export default {
	  	name: 'vipInContainer',
	  	data(){
		  	return{
		  		readingIndex:false, //入会须知已读
		  		vipSuccess:false,   //用户入会成功提示
		  	}
	  	},
	  	methods:{
	  		reading:function(){
	  			this.readingIndex = !this.readingIndex;
	  		},
	  		cancle:function(){
	  			window.location = document.referrer;
	  		},
	  		confirm:function(){
	  			if(this.readingIndex){
	  				Server.vipIn().then((result)=>{
	  					if(result.code == '0'){ //用户已入会
				    		this.vipSuccess = true;
				    	}
	  				})
	  				// this.vipSuccess = true;
	  			}else{
	  				alertMsg('请确认已阅读入会须知内容');
	  			}
	  		},
	  		vipInSucc:function(){
	  			window.location = document.referrer;
	  		}
	  	},
	  	mounted(){
			//
	  	}
	}
</script>
<style lang="less" scoped>
	.vipInContainer{
		margin-top: 150px;
		width:100%;
		.text-container{
			width:100%;
			padding:0 40px;
			.title{
				width:100%;
				font-size:48px;
				color:#000000;
				letter-spacing:0;
				line-height:92px;
				text-align:left;
			}
			.content{
				margin-top:40px;
				width:100%;
				font-size:28px;
				color:#000000;
				letter-spacing:0.09px;
				line-height:40px;
				text-align:left;
			}
			.state{
				display:flex;
				justify-content:center;
				align-items:center;
				height:50px;
				margin-top:100px;
				width:100%;
				.imgContainer{
					background:#ad8f5a;
					border-radius:8px;
					width:40px;
					height:40px;
					text-align:center;
					img{
						width:28px;
						vertical-align:middle;
						margin-top:10px;
					}
				}
				.not-confirm{
					background:#b9b9b9;
				}
				.state-text{
					font-size:28px;
					color:#333333;
					letter-spacing:0;
					text-align:left;
					height:40px;
					line-height:40px;
					margin-left:25px;
				}
			}
			.confirmBox{
				margin-top:100px;
				width:100%;
				display:flex;
				justify-content:space-between;
				font-size:28px;
				text-align:center;
				letter-spacing:1px;
				.cancle{
					border:2px solid #ad8f5a;
					border-radius:8px;
					width:45%;
					height:100px;
					line-height:96px;
					color:#ad8f5a;
				}
				.confirm{
					background-image:linear-gradient(90deg, #f1e3bb 0%, #e0c385 100%);
					border-radius:8px;
					width:45%;
					height:100px;
					line-height:100px;
					color:#ffffff;
				}
			}
		}
		.resulr-container{
			.result-bg{
				width:100%;
				height:760px;
				background-image:url(../../assets/img/result-bg.png);
				background-size:100% 100%;
				padding:1px;
				.result-text{
					width:54%;
					height:470px;
					margin-top:160px;
					margin-left:23%;
					background:#ffffff;
					text-align:center;
					img{
						width:220px;
						margin-top:70px;
					}
					.result-wel{
						margin-top:40px;
						font-size:28px;
						color:#000000;
						letter-spacing:0;
						line-height:92px;
						text-align:center;
						margin-bottom:50px;
					}
				}
			}
			.result-confirm{
				background-image:linear-gradient(90deg, #f1e3bb 0%, #e0c385 100%);
				width:42%;
				height:100px;
				border-radius:8px;
				margin-top:40px;
				margin-left:29%;
				line-height:100px;
				text-align:center;
				color:#fff;
				letter-spacing:1px;
				font-size:28px;
			}
		}
		.none{
			display:none;
		}
		
	}

</style>


// WEBPACK FOOTER //
// src/components/vipIn/vipIn.vue